var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogOut = function SvgLogOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2,
    d: "M10.667 11.333 14 8m0 0-3.333-3.333M14 8H6m2 3.333c0 .197 0 .296-.007.381a2 2 0 0 1-1.603 1.79c-.084.018-.182.028-.378.05l-.68.076c-1.024.113-1.535.17-1.942.04a2 2 0 0 1-1.216-1.088C2 12.192 2 11.677 2 10.648V5.352c0-1.03 0-1.544.174-1.934A2 2 0 0 1 3.39 2.33c.407-.13.918-.074 1.941.04l.681.076c.196.022.294.032.378.05a2 2 0 0 1 1.603 1.79C8 4.37 8 4.47 8 4.666"
  })));
};
export default SvgLogOut;